export default __webpack_public_path__ + "static/media/rekisteröityminen.46885095.png";